export interface ApiKeyRequest {
  clientIdentifier: string;
  appName: string;
}
